function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002A33;}\n\t.st2{clip-path:url(#SVGID_00000063613293979189552110000015357943523105662116_);}\n\t.st3{fill:#6CB9B2;}\n\t.st4{fill:#684AAD;}\n\t.st5{fill:#D29242;}\n\t.st6{fill:#B2CDF8;}\n\t.st7{fill:#60789C;}\n\t.st8{fill:#334058;}\n\t.st9{opacity:0.5;fill:#334058;enable-background:new    ;}\n\t.st10{fill:#A1BAE1;}\n\t.st11{fill:#7089B0;}\n\t.st12{fill:#EF4A60;}\n\t.st13{opacity:0.5;fill:#F86372;enable-background:new    ;}\n\t.st14{opacity:0.4;fill:#F86372;enable-background:new    ;}\n\t.st15{opacity:0.5;fill:#7089B0;enable-background:new    ;}\n\t.st16{fill:#82A2D6;}\n\t.st17{fill:#FB4A61;}\n\t.st18{opacity:0.5;fill:#AEB5BD;enable-background:new    ;}\n\t.st19{opacity:0.5;}\n\t.st20{fill:#BB323D;}\n\t.st21{opacity:0.3;}\n\t.st22{opacity:0.3;fill:#BB323D;enable-background:new    ;}\n\t.st23{fill:#F86372;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 139.9,
  cy: 139.9,
  r: 131.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.9,279.7C62.7,279.7,0,217,0,139.9S62.7,0,139.9,0s139.9,62.7,139.9,139.9S217,279.7,139.9,279.7z  M139.9,17C72.1,17,17,72.1,17,139.9s55.1,122.9,122.9,122.9s122.9-55.1,122.9-122.9S207.6,17,139.9,17z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "SVGID_1_",
  cx: 140,
  cy: 139.8,
  rx: 123.1,
  ry: 122.6
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -22.6,
  y: -9.5,
  className: "st3",
  width: 319.4,
  height: 319.4
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M78.8,68.8c-7.1-4.2-14.3,4.2-21.4,0v-5.5c7.1,4.2,14.3-4.2,21.4,0c-2.4-0.5-4.9,0.4-7.3,1.8 C73.9,65.6,76.3,66.5,78.8,68.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M57.3,84.8c-0.2,0-0.3-0.1-0.3-0.3V62.9c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v21.5 C57.7,84.6,57.5,84.8,57.3,84.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 43,
  y: 142.9,
  className: "st6",
  width: 28.8,
  height: 49
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "71.9,142.9 43,142.9 40.4,138.9 74.5,138.9  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M60,157.7h-5.2v-8.9c0-1.4,1.2-2.6,2.6-2.6l0,0c1.4,0,2.6,1.2,2.6,2.6L60,157.7L60,157.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M57.9,146.2c-0.2,0-0.3-0.1-0.5-0.1c-1.4,0-2.6,1.2-2.6,2.6v8.9h1.1v-8.9 C55.9,147.5,56.8,146.5,57.9,146.2L57.9,146.2z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M61.7,158.4h-8.3c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h8.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C62,158.3,61.9,158.4,61.7,158.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 54.8,
  y: 158.4,
  className: "st11",
  width: 5.4,
  height: 1.1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M46.6,142.9h-2.6l-1.2-2.5c-0.3-0.6,0.1-1.1,0.9-1.1l0,0c0.8,0,1.7,0.5,1.9,1.1L46.6,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M51.5,142.9h-2.6l-0.8-2.5c-0.2-0.6,0.3-1.1,1.1-1.1l0,0c0.8,0,1.6,0.5,1.7,1.1L51.5,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M56.3,142.9h-2.6l-0.3-2.5c-0.1-0.6,0.5-1.1,1.3-1.1l0,0c0.8,0,1.5,0.5,1.5,1.1L56.3,142.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M61.2,142.9h-2.6l0.1-2.5c0-0.6,0.7-1.1,1.5-1.1l0,0c0.8,0,1.4,0.5,1.3,1.1L61.2,142.9L61.2,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M66.1,142.9h-2.6l0.5-2.5c0.1-0.6,0.9-1.1,1.7-1.1l0,0c0.8,0,1.3,0.5,1.1,1.1 C66.8,140.5,66.1,142.9,66.1,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M70.9,142.9h-2.6l1-2.5c0.2-0.6,1.1-1.1,1.9-1.1l0,0c0.8,0,1.2,0.5,0.9,1.1L70.9,142.9L70.9,142.9z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st12",
  points: "68.6,127.6 57.5,78 57.2,78 46.1,127.6 39.1,138.9 75.6,138.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "68.6,127.5 57.5,78 57.2,78 46.1,127.5  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "57.3,138.9 75.6,138.9 68.6,127.6 57.5,78 57.3,78  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "57.4,138.9 57.4,191.9 71.7,191.9 71.7,142.9 71.9,142.9 74.5,138.9  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M242.1,68.8c-7.1-4.2-14.3,4.2-21.4,0v-5.5c7.1,4.2,14.3-4.2,21.4,0c-2.4-0.5-4.9,0.4-7.4,1.8 C237.2,65.6,239.7,66.5,242.1,68.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M220.7,84.8c-0.2,0-0.3-0.1-0.3-0.3V62.9c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v21.5 C221,84.6,220.9,84.8,220.7,84.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 206.3,
  y: 142.9,
  className: "st6",
  width: 28.8,
  height: 49
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "235.3,142.9 206.3,142.9 203.8,138.9 237.8,138.9  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M223.4,157.7h-5.2v-8.9c0-1.4,1.2-2.6,2.6-2.6l0,0c1.4,0,2.6,1.2,2.6,2.6L223.4,157.7L223.4,157.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M221.3,146.2c-0.2,0-0.4-0.1-0.5-0.1c-1.4,0-2.6,1.2-2.6,2.6v8.9h1.1v-8.9 C219.2,147.5,220.1,146.5,221.3,146.2L221.3,146.2z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M225,158.4h-8.4c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h8.4c0.2,0,0.4,0.2,0.4,0.4l0,0 C225.4,158.3,225.2,158.4,225,158.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 218.2,
  y: 158.4,
  className: "st11",
  width: 5.4,
  height: 1.1
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M210,142.9h-2.6l-1.2-2.5c-0.3-0.6,0.1-1.1,0.9-1.1l0,0c0.8,0,1.6,0.5,1.9,1.1L210,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M214.8,142.9h-2.6l-0.8-2.5c-0.2-0.6,0.3-1.1,1.1-1.1l0,0c0.8,0,1.6,0.5,1.7,1.1L214.8,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M219.7,142.9h-2.6l-0.3-2.5c-0.1-0.6,0.5-1.1,1.3-1.1l0,0c0.8,0,1.5,0.5,1.5,1.1L219.7,142.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M224.6,142.9H222l0.1-2.5c0-0.6,0.7-1.1,1.5-1.1l0,0c0.8,0,1.4,0.5,1.3,1.1L224.6,142.9L224.6,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M229.4,142.9h-2.6l0.5-2.5c0.1-0.6,0.9-1.1,1.7-1.1l0,0c0.8,0,1.3,0.5,1.1,1.1L229.4,142.9 L229.4,142.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M234.3,142.9h-2.6l1-2.5c0.2-0.6,1.1-1.1,1.9-1.1l0,0c0.8,0,1.2,0.5,0.9,1.1L234.3,142.9L234.3,142.9z "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st12",
  points: "231.9,127.6 220.8,78 220.6,78 209.4,127.6 202.5,138.9 238.9,138.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "231.9,127.5 220.8,78 220.6,78 209.5,127.5  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "220.7,138.9 238.9,138.9 231.9,127.6 220.8,78 220.7,78  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "220.8,138.9 220.8,191.9 235.1,191.9 235.1,142.9 235.3,142.9 237.8,138.9  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M101.3,52c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4l2.7-2.7c0.1-0.1,0.3-0.1,0.4,0s0.1,0.3,0,0.4 l-2.7,2.7C101.4,52,101.4,52,101.3,52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M101.3,52c-0.1,0-0.2,0-0.2-0.1l-2.5-2.5c-0.1-0.1-0.1-0.3,0-0.4s0.3-0.1,0.4,0l2.5,2.5 c0.1,0.1,0.1,0.3,0,0.4C101.4,52,101.4,52,101.3,52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M101.3,73.5c-0.2,0-0.3-0.1-0.3-0.3V51.7c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v21.5 C101.6,73.4,101.4,73.5,101.3,73.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 93.9,
  y: 92,
  className: "st16",
  width: 14.8,
  height: 23.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 99.5,
  y: 98.5,
  className: "st8",
  width: 3.5,
  height: 10.3
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "107.4,87.1 101.4,65.9 101.3,65.9 95.3,87.1 91.5,92 111.2,92  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "111.2,92 107.4,87.1 101.4,65.9 101.3,65.9 101.3,65.9 101.3,115.3 108.7,115.3 108.7,92  108.7,92  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M177.6,52c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4l2.6-2.7c0.1-0.1,0.3-0.1,0.4,0s0.1,0.3,0,0.4 l-2.6,2.7C177.8,52,177.7,52,177.6,52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M177.6,52c-0.1,0-0.2,0-0.2-0.1l-2.5-2.5c-0.1-0.1-0.1-0.3,0-0.4s0.3-0.1,0.4,0l2.5,2.5 c0.1,0.1,0.1,0.3,0,0.4C177.8,52,177.7,52,177.6,52z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M177.6,73.5c-0.2,0-0.3-0.1-0.3-0.3V51.7c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3v21.5 C177.9,73.4,177.8,73.5,177.6,73.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 170.2,
  y: 92,
  className: "st16",
  width: 14.8,
  height: 23.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 175.9,
  y: 98.5,
  className: "st8",
  width: 3.5,
  height: 10.3
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "183.8,87.1 177.8,65.9 177.6,65.9 171.6,87.1 167.9,92 187.6,92  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "187.6,92 183.8,87.1 177.8,65.9 177.6,65.9 177.6,65.9 177.6,115.3 185.1,115.3 185.1,92  185.1,92  "
})), /*#__PURE__*/React.createElement("rect", {
  x: 120.8,
  y: 60,
  className: "st16",
  width: 36.4,
  height: 58.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 120.8,
  y: 60,
  className: "st7",
  width: 36.4,
  height: 15.6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "182,141.7 96.6,141.7 91,132.8 187.6,132.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "176.7,108 176.7,113.3 166.1,113.3 166.1,108 155.2,108 155.2,113.3 144.6,113.3 144.6,108  133.8,108 133.8,113.3 123.2,113.3 123.2,108 112.3,108 112.3,113.3 101.7,113.3 101.7,108 91.1,108 91.1,132.8  187.6,132.8 187.6,108  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 103.7,
  y: 118.2,
  className: "st8",
  width: 6.7,
  height: 8.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 103.7,
  y: 118.2,
  className: "st9",
  width: 2.3,
  height: 8.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 125.1,
  y: 118.2,
  className: "st8",
  width: 6.7,
  height: 8.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 125.1,
  y: 118.2,
  className: "st9",
  width: 2.3,
  height: 8.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 146.5,
  y: 118.2,
  className: "st8",
  width: 6.7,
  height: 8.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 146.5,
  y: 118.2,
  className: "st9",
  width: 2.3,
  height: 8.3
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 167.9,
  y: 118.2,
  className: "st8",
  width: 6.7,
  height: 8.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 167.9,
  y: 118.2,
  className: "st9",
  width: 2.3,
  height: 8.3
}))), /*#__PURE__*/React.createElement("g", {
  className: "st19"
}, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M104,141.7h-4.8l-2-4.5c-0.6-1.3,0.1-2.3,1.6-2.3l0,0c1.4,0,3,1.1,3.5,2.3L104,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M114.7,141.7h-4.8l-1.5-4.5c-0.4-1.3,0.4-2.3,1.8-2.3l0,0c1.4,0,2.9,1.1,3.2,2.3L114.7,141.7 L114.7,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M125.5,141.7h-4.8l-0.9-4.5c-0.3-1.3,0.7-2.3,2.1-2.3l0,0c1.4,0,2.7,1.1,2.9,2.3L125.5,141.7 L125.5,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M136.3,141.7h-4.8l-0.4-4.5c-0.1-1.3,0.9-2.3,2.4-2.3l0,0c1.4,0,2.6,1.1,2.7,2.3L136.3,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M147.1,141.7h-4.8l0.1-4.5c0-1.3,1.2-2.3,2.7-2.3l0,0c1.4,0,2.5,1.1,2.4,2.3L147.1,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M157.9,141.7h-4.8l0.7-4.5c0.2-1.3,1.5-2.3,2.9-2.3l0,0c1.4,0,2.4,1.1,2.1,2.3L157.9,141.7 L157.9,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M168.7,141.7h-4.8l1.2-4.5c0.4-1.3,1.8-2.3,3.2-2.3l0,0c1.4,0,2.2,1.1,1.8,2.3L168.7,141.7 L168.7,141.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M179.5,141.7h-4.8l1.8-4.5c0.5-1.3,2.1-2.3,3.5-2.3l0,0c1.4,0,2.1,1.1,1.6,2.3L179.5,141.7z"
}))), /*#__PURE__*/React.createElement("rect", {
  x: 96.6,
  y: 141.7,
  className: "st11",
  width: 85.2,
  height: 22.3
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st6",
  points: "160.4,68.3 160.4,71.3 154.4,71.3 154.4,68.3 148.3,68.3 148.3,71.3 142.3,71.3 142.3,68.3  136.2,68.3 136.2,71.3 130.2,71.3 130.2,68.3 124.1,68.3 124.1,71.3 118.1,71.3 118.1,68.3 112.1,68.3 112.1,79.2  166.5,79.2 166.5,68.3  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "157.6,55.8 139.4,33 138.9,33 120.7,55.8 110.1,63.9 168.2,63.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "157.6,55.8 139.4,33 138.9,33 120.7,55.8  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "139.1,63.9 168.2,63.9 157.6,55.8 139.4,33 139.1,33  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "157.1,88.1 120.8,88.1 112.1,79.2 166.5,79.2  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M141.8,104.4H136v-9.9c0-1.6,1.3-2.9,2.9-2.9l0,0c1.6,0,2.9,1.3,2.9,2.9V104.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M139.5,91.7c-0.2,0-0.4-0.1-0.6-0.1c-1.6,0-2.9,1.3-2.9,2.9v9.9h1.2v-9.9 C137.2,93.1,138.1,92,139.5,91.7L139.5,91.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143.6,105.3h-9.3c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C144,105.1,143.8,105.3,143.6,105.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M141.8,159.5H136v-9.9c0-1.6,1.3-2.9,2.9-2.9l0,0c1.6,0,2.9,1.3,2.9,2.9V159.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M139.5,146.8c-0.2,0-0.4-0.1-0.6-0.1c-1.6,0-2.9,1.3-2.9,2.9v9.9h1.2v-9.9 C137.2,148.2,138.1,147.1,139.5,146.8L139.5,146.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M143.6,160.4h-9.3c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C144,160.2,143.8,160.4,143.6,160.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M125.4,159.5h-5.8v-9.9c0-1.6,1.3-2.9,2.9-2.9l0,0c1.6,0,2.9,1.3,2.9,2.9V159.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M123.2,146.8c-0.2,0-0.4-0.1-0.6-0.1c-1.6,0-2.9,1.3-2.9,2.9v9.9h1.2v-9.9 C120.9,148.2,121.8,147.1,123.2,146.8L123.2,146.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M127.3,160.4H118c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C127.7,160.2,127.5,160.4,127.3,160.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M109.1,159.5h-5.8v-9.9c0-1.6,1.3-2.9,2.9-2.9l0,0c1.6,0,2.9,1.3,2.9,2.9V159.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M106.8,146.8c-0.2,0-0.4-0.1-0.6-0.1c-1.6,0-2.9,1.3-2.9,2.9v9.9h1.2v-9.9 C104.6,148.2,105.5,147.1,106.8,146.8L106.8,146.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M111,160.4h-9.3c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C111.4,160.2,111.2,160.4,111,160.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M174.6,159.5h-5.8v-9.9c0-1.6,1.3-2.9,2.9-2.9l0,0c1.6,0,2.9,1.3,2.9,2.9V159.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M172.3,146.8c-0.2,0-0.4-0.1-0.6-0.1c-1.6,0-2.9,1.3-2.9,2.9v9.9h1.2v-9.9 C170,148.2,171,147.1,172.3,146.8L172.3,146.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M176.5,160.4h-9.3c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C176.9,160.2,176.7,160.4,176.5,160.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M158.3,159.5h-5.8v-9.9c0-1.6,1.3-2.9,2.9-2.9l0,0c1.6,0,2.9,1.3,2.9,2.9V159.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M156,146.8c-0.2,0-0.4-0.1-0.6-0.1c-1.6,0-2.9,1.3-2.9,2.9v9.9h1.2v-9.9 C153.7,148.2,154.7,147.1,156,146.8L156,146.8z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M160.2,160.4h-9.3c-0.2,0-0.4-0.2-0.4-0.4l0,0c0-0.2,0.2-0.4,0.4-0.4h9.3c0.2,0,0.4,0.2,0.4,0.4l0,0 C160.6,160.2,160.4,160.4,160.2,160.4z"
})))), /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 199.3,
  className: "st16",
  width: 245.8,
  height: 78.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 134.9,
  y: 199.3,
  className: "st15",
  width: 36,
  height: 78.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 163.5,
  className: "st20",
  width: 245.8,
  height: 35.8
}), /*#__PURE__*/React.createElement("g", {
  className: "st21"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "55,199.3 63.4,199.3 66.5,190.2 58,190.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "65.8,179.9 65.7,179.9 59.5,188.3 56.7,190.2 67.9,190.2 66.4,188.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "87.9,199.3 96.4,199.3 99.4,190.2 91,190.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "98.7,179.9 98.7,179.9 92.4,188.3 89.6,190.2 100.9,190.2 99.4,188.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "183.5,199.3 191.9,199.3 195,190.2 186.6,190.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "194.3,179.9 194.2,179.9 188,188.3 185.2,190.2 196.4,190.2 194.9,188.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "216.4,199.3 224.9,199.3 228,190.2 219.5,190.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "227.9,188.3 227.2,179.9 227.2,179.9 220.9,188.3 218.1,190.2 229.4,190.2  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M54.5,229.7h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4 C54.5,217.9,54.5,229.7,54.5,229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M51.8,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C49.1,216.3,50.2,214.9,51.8,214.6L51.8,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M56.7,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C57.2,230.4,57,230.7,56.7,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 47.7,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M70.3,229.7h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M67.6,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C64.9,216.3,66,214.9,67.6,214.6L67.6,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M72.5,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C73,230.4,72.8,230.7,72.5,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63.5,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M86.1,229.7h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M83.4,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C80.7,216.3,81.8,214.9,83.4,214.6L83.4,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M88.3,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C88.8,230.4,88.6,230.7,88.3,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 79.2,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M101.9,229.7H95v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4 C101.9,217.9,101.9,229.7,101.9,229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M99.2,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C96.5,216.3,97.6,214.9,99.2,214.6L99.2,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M104.1,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C104.6,230.4,104.3,230.7,104.1,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 95,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M54.5,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4C54.5,247.2,54.5,259,54.5,259z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M51.8,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C49.1,245.6,50.2,244.2,51.8,243.9L51.8,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M56.7,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C57.2,259.8,57,260,56.7,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 47.7,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M70.3,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M67.6,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C64.9,245.6,66,244.2,67.6,243.9L67.6,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M72.5,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C73,259.8,72.8,260,72.5,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 63.5,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M86.1,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M83.4,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C80.7,245.6,81.8,244.2,83.4,243.9L83.4,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M88.3,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C88.8,259.8,88.6,260,88.3,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 79.2,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M101.9,259H95v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4 C101.9,247.2,101.9,259,101.9,259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M99.2,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C96.5,245.6,97.6,244.2,99.2,243.9L99.2,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M104.1,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C104.6,259.8,104.3,260,104.1,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 95,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M183.1,229.7h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M180.4,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C177.6,216.3,178.8,214.9,180.4,214.6L180.4,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M185.3,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C185.8,230.4,185.6,230.7,185.3,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 176.2,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M198.9,229.7H192v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M196.2,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C193.4,216.3,194.6,214.9,196.2,214.6L196.2,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M201.1,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C201.6,230.4,201.4,230.7,201.1,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 192,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M214.7,229.7h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M211.9,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C209.2,216.3,210.4,214.9,211.9,214.6L211.9,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M216.9,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C217.4,230.4,217.1,230.7,216.9,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 207.8,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M230.4,229.7h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V229.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M227.7,214.6c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4v11.7h1.4v-11.7 C225,216.3,226.2,214.9,227.7,214.6L227.7,214.6z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M232.6,230.7h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C233.1,230.4,232.9,230.7,232.6,230.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 223.6,
  y: 230.7,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M183.1,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M180.4,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C177.6,245.6,178.8,244.2,180.4,243.9L180.4,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M185.3,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C185.8,259.8,185.6,260,185.3,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 176.2,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M198.9,259H192v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M196.2,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C193.4,245.6,194.6,244.2,196.2,243.9L196.2,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M201.1,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C201.6,259.8,201.4,260,201.1,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 192,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M214.7,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M211.9,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C209.2,245.6,210.4,244.2,211.9,243.9L211.9,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M216.9,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C217.4,259.8,217.1,260,216.9,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 207.8,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M230.4,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M227.7,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C225,245.6,226.2,244.2,227.7,243.9L227.7,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M232.6,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C233.1,259.8,232.9,260,232.6,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 223.6,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 54.3,
  y: 186.1,
  className: "st16",
  width: 8.5,
  height: 13.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 189.8,
  className: "st8",
  width: 2,
  height: 5.9
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "62,183.3 58.6,171.1 58.5,171.1 55.1,183.3 52.9,186.1 64.2,186.1  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 87.2,
  y: 186.1,
  className: "st16",
  width: 8.5,
  height: 13.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 90.4,
  y: 189.8,
  className: "st8",
  width: 2,
  height: 5.9
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "94.9,183.3 91.5,171.1 91.4,171.1 88,183.3 85.8,186.1 97.1,186.1  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 182.8,
  y: 186.1,
  className: "st16",
  width: 8.5,
  height: 13.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 186,
  y: 189.8,
  className: "st8",
  width: 2,
  height: 5.9
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "190.5,183.3 187.1,171.1 187,171.1 183.6,183.3 181.4,186.1 192.7,186.1  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 215.7,
  y: 186.1,
  className: "st16",
  width: 8.5,
  height: 13.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 218.9,
  y: 189.8,
  className: "st8",
  width: 2,
  height: 5.9
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "223.5,183.3 220,171.1 219.9,171.1 216.5,183.3 214.4,186.1 225.6,186.1  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M147.7,166.2l-4.1-2c-0.5-0.2-1.3,0.1-1.4,0.7l-2.7,10.3l-1.1,1.3l-3.3-1.6c-0.5-0.2-1.3,0.1-1.4,0.7 l-2.2,8.5l-2.4,2.6l-2.5-1.2c-0.5-0.2-1.3,0.1-1.4,0.7l-1.7,6.7l-6,6.6H171l-2.6-6.3l1.8-7c0.1-0.6-0.4-0.9-1.1-0.7l-3.4,1.3 l-0.9-2.3l2.3-8.9c0.1-0.6-0.4-0.9-1.1-0.7l-4.5,1.7l-0.3-0.9l2.8-10.8c0.1-0.6-0.4-0.9-1.1-0.7l-5.6,2.1l-1.1-2.8h-6.4 L147.7,166.2L147.7,166.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M162,191.9V184c0-0.6-0.7-1.1-1.2-0.8l-3,1.5l-1.6-2.6v-10c0-0.6-0.7-1.1-1.2-0.8l-4,1.9l-0.6-0.9 v-12.2c0-0.6-0.7-1.1-1.2-0.8l-5,2.4l-3.9-6.5c-0.5-0.9-1.8-0.9-2.4,0l-3.7,6.4l-4.7-2.3c-0.6-0.3-1.2,0.1-1.2,0.8v11.6 l-0.8,1.4l-3.8-1.8c-0.6-0.3-1.2,0.1-1.2,0.8v9.6l-1.7,3l-2.8-1.4c-0.6-0.3-1.2,0.1-1.2,0.8v7.6l-4.3,7.4v78.4h53.8V199 L162,191.9L162,191.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "115.4,277.4 115.4,199.8 119.8,192.4 119.8,187.5 122,188.6 125.6,182.4 125.6,175.5 128.7,177  131.4,172.5 131.4,163.6 135.4,165.5 139.1,159.2 142.9,165.7 147.3,163.6 147.3,173.1 149.7,177.2 153.1,175.5 153.1,182.9  156.5,188.6 158.9,187.5 158.9,192.7 163.1,199.8 163.1,277.4  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M139.3,199.8c-6.2,0-11.3-5.1-11.3-11.3s5.1-11.3,11.3-11.3s11.3,5.1,11.3,11.3 S145.5,199.8,139.3,199.8z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 139.3,
  cy: 188.5,
  r: 10
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "145.4,189.7 149.3,188.3 145.4,187.1 144,188.4  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M139.3,192.7l-1.9,1.8l0.9,4c0.3,0,0.6,0.1,1,0.1c0.4,0,0.9,0,1.3-0.1l0.8-4L139.3,192.7L139.3,192.7 z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "143.4,183.8 144.1,179.8 141.1,182.5 141.6,184.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "141.3,194.4 144.4,197.1 143.5,193.1 141.7,192.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "135.2,193.2 134.4,197.2 137.4,194.5 137,192.6  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M135.6,186.4l-0.6-2.6l-3.9-1.2c-0.4,0.6-0.8,1.3-1.1,2l3.1,2.7L135.6,186.4L135.6,186.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M142.9,190.5l0.6,2.6l3.9,1.2c0.4-0.6,0.8-1.3,1.1-2l-3.1-2.7L142.9,190.5L142.9,190.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M139.2,184.3l1.9-1.8l-0.9-4c-0.3,0-0.6-0.1-1-0.1c-0.4,0-0.9,0-1.3,0.1l-0.8,4L139.2,184.3 L139.2,184.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M135.7,190.6l-2.5-0.8l-3,2.8c0.3,0.7,0.7,1.3,1.2,1.9l3.9-1.4L135.7,190.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M142.9,186.4l2.5,0.8l3-2.8c-0.3-0.7-0.7-1.3-1.2-1.9l-3.9,1.4L142.9,186.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "137.2,182.6 134.1,179.9 135,183.9 136.9,184.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "133.1,187.3 129.3,188.6 133.2,189.9 134.6,188.6  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "142.7,189.6 142.9,190.5 145.4,189.7 144,188.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "140.1,192 139.3,192.7 141.3,194.4 141.7,192.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "144,188.4 145.4,187.1 142.9,186.4 142.7,187.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "137,192.6 137.4,194.5 139.3,192.7 138.6,192.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "142,190.9 141.7,192.5 143.5,193.1 142.9,190.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "136.6,190.9 135.7,190.6 135.2,193.2 137,192.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "138.4,185 139.2,184.3 137.2,182.6 136.9,184.5  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "141.9,186.1 142.9,186.4 143.4,183.8 141.6,184.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "141.6,184.4 141.1,182.5 139.2,184.3 139.9,184.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "136.9,184.5 135,183.9 135.6,186.4 136.5,186.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "134.6,188.6 133.2,189.9 135.7,190.6 135.9,189.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st8",
  points: "135.8,187.4 135.6,186.4 133.1,187.3 134.6,188.6  "
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "138.6,192.1 139.4,191.8 137.7,191.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "136.6,190.9 137,192.6 138.6,192.1 137.7,191.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "135.9,189.7 136.4,190.2 136.1,188.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "136.4,190.2 136.6,190.9 137.7,191.3  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "140.1,192 141.7,192.5 142,190.9 140.9,191.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.1,190.1 142,190.9 142.9,190.5 142.7,189.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "139.4,191.8 140.1,192 140.9,191.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "140.9,191.2 142,190.9 142.1,190.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "135.8,187.4 134.6,188.6 135.9,189.7 136.1,188.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.1,190.1 142.5,188.4 142.1,186.8 140.9,185.7 139.2,185.2 137.6,185.8 136.4,186.9  136.1,188.6 136.4,190.2 137.7,191.3 139.4,191.8 140.9,191.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.7,189.6 144,188.4 142.7,187.3 142.5,188.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.1,186.8 141.9,186.1 140.9,185.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.7,187.3 142.1,186.8 142.5,188.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.1,190.1 142.7,189.6 142.5,188.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "136.5,186.1 136.4,186.9 137.6,185.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "138.4,185 136.9,184.5 136.5,186.1 137.6,185.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "136.4,186.9 135.8,187.4 136.1,188.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "141.9,186.1 141.6,184.4 139.9,184.9 140.9,185.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "139.2,185.2 138.4,185 137.6,185.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "139.9,184.9 139.2,185.2 140.9,185.7  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "139.4,191.8 138.6,192.1 139.3,192.7 140.1,192  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "139.2,185.2 139.9,184.9 139.2,184.3 138.4,185  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "136.4,190.2 135.9,189.7 135.7,190.6 136.6,190.9  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "142.1,186.8 142.7,187.3 142.9,186.4 141.9,186.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "136.4,186.9 136.5,186.1 135.6,186.4 135.8,187.4  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "139.2,185.2 137.6,185.8 136.4,186.9 136.1,188.6 136.4,190.2 137.7,191.3 139.4,191.8  140.9,191.2 142.1,190.1 142.5,188.4 142.1,186.8 140.9,185.7  "
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st23",
  d: "M139.4,203.4c0,0-18.6,8.2-18.6,22.8v51.3h37.2v-51.3C157.9,211.6,139.4,203.4,139.4,203.4L139.4,203.4 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st20",
  d: "M139.4,203.4c0,0-2.9,1.3-6.3,3.7c1.5,1.1,3.6,2.7,6.3,5.1c2.8-2.4,4.8-4,6.3-5.1 C142.2,204.6,139.4,203.4,139.4,203.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M139.4,212.1c0,0-2.9,2-6.3,5.9c1.5,1.7,3.6,4.3,6.3,8.1c2.8-3.8,4.8-6.4,6.3-8.1 C142.2,214.1,139.4,212.1,139.4,212.1z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 120.8,
  y: 253.4,
  className: "st11",
  width: 37.2,
  height: 6.6
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M126.2,256.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S126.2,256.2,126.2,256.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M131,256.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S131,256.2,131,256.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M135.8,256.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S135.8,256.2,135.8,256.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M144.5,256.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S144.5,256.2,144.5,256.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M149.3,256.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S149.3,256.2,149.3,256.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M154.1,256.7c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9S154.1,256.2,154.1,256.7z"
}))), /*#__PURE__*/React.createElement("rect", {
  x: 138.8,
  y: 224.4,
  className: "st8",
  width: 1.1,
  height: 53
}), /*#__PURE__*/React.createElement("rect", {
  x: 120.8,
  y: 239.1,
  className: "st8",
  width: 1.5,
  height: 5.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 156.4,
  y: 239.1,
  className: "st8",
  width: 1.5,
  height: 5.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 120.8,
  y: 267.1,
  className: "st8",
  width: 1.5,
  height: 5.6
}), /*#__PURE__*/React.createElement("rect", {
  x: 156.4,
  y: 267.1,
  className: "st8",
  width: 1.5,
  height: 5.6
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M46.8,86.8c-8.5-4.9-17,4.9-25.5,0v-6.5c8.5,4.9,17-4.9,25.5,0c-2.9-0.6-5.8,0.5-8.7,2.2 C41,83,43.9,84,46.8,86.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M21.4,105.8c-0.2,0-0.4-0.2-0.4-0.4V79.8c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v25.6 C21.8,105.6,21.6,105.8,21.4,105.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M52.1,226.6l5.2-7.5h0.6c0.4,0,0.7-0.3,0.7-0.7v-18.8c0-0.1,0-0.2-0.1-0.3h-20v78.1h13.4v-50.8 L52.1,226.6L52.1,226.6z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 4.3,
  y: 174.9,
  className: "st10",
  width: 34.2,
  height: 102.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M-1.8,199h46.6c0.2,0,0.4,0.2,0.4,0.4v19.4c0,0.2-0.2,0.4-0.4,0.4H-1.8c-0.2,0-0.4-0.2-0.4-0.4v-19.4 C-2.2,199.2-2,199-1.8,199z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st11",
  points: "38.7,226.6 4.3,226.6 -0.9,219.1 43.9,219.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "38.5,174.9 4.3,174.9 1.3,170.1 41.5,170.1  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M0.5,214.8L0.5,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C1.3,214.4,0.9,214.8,0.5,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M4,214.8L4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8V214 C4.8,214.4,4.4,214.8,4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M7.5,214.8L7.5,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C8.3,214.4,7.9,214.8,7.5,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M11,214.8L11,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C11.8,214.4,11.4,214.8,11,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M14.5,214.8L14.5,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C15.3,214.4,14.9,214.8,14.5,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M18,214.8L18,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C18.8,214.4,18.5,214.8,18,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M21.5,214.8L21.5,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C22.3,214.4,22,214.8,21.5,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M25,214.8L25,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C25.8,214.4,25.5,214.8,25,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M28.5,214.8L28.5,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C29.3,214.4,29,214.8,28.5,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M32,214.8L32,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C32.8,214.4,32.5,214.8,32,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M35.5,214.8L35.5,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C36.3,214.4,36,214.8,35.5,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M39,214.8L39,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0c0.4,0,0.8,0.3,0.8,0.8 V214C39.8,214.4,39.5,214.8,39,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M42.6,214.8L42.6,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C43.3,214.4,43,214.8,42.6,214.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M12.9,190.4H9v-6.7c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2L12.9,190.4L12.9,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M11.4,181.7c-0.1,0-0.3,0-0.4,0c-1.1,0-2,0.9-2,2v6.7h0.8v-6.7C9.8,182.7,10.5,181.9,11.4,181.7 L11.4,181.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M14.2,191H7.9c-0.2,0-0.3-0.1-0.3-0.3l0,0c0-0.2,0.1-0.3,0.3-0.3h6.3c0.2,0,0.3,0.1,0.3,0.3l0,0 C14.5,190.9,14.4,191,14.2,191z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 191,
  className: "st11",
  width: 4.1,
  height: 0.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M23.5,190.4h-3.9v-6.7c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2L23.5,190.4L23.5,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M21.9,181.7c-0.1,0-0.3,0-0.4,0c-1.1,0-2,0.9-2,2v6.7h0.8v-6.7C20.3,182.7,21,181.9,21.9,181.7 L21.9,181.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M24.7,191h-6.3c-0.2,0-0.3-0.1-0.3-0.3l0,0c0-0.2,0.1-0.3,0.3-0.3h6.3c0.2,0,0.3,0.1,0.3,0.3l0,0 C25,190.9,24.9,191,24.7,191z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 19.5,
  y: 191,
  className: "st11",
  width: 4.1,
  height: 0.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M24.9,259H18v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4V259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M22.1,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C19.4,245.6,20.6,244.2,22.1,243.9L22.1,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M27,260H16c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C27.5,259.8,27.3,260,27,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M34,190.4H30v-6.7c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2L34,190.4L34,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M32.4,181.7c-0.1,0-0.3,0-0.4,0c-1.1,0-2,0.9-2,2v6.7h0.8v-6.7C30.8,182.7,31.5,181.9,32.4,181.7 L32.4,181.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M35.2,191h-6.3c-0.2,0-0.3-0.1-0.3-0.3l0,0c0-0.2,0.1-0.3,0.3-0.3h6.3c0.2,0,0.3,0.1,0.3,0.3l0,0 C35.5,190.9,35.4,191,35.2,191z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 191,
  className: "st11",
  width: 4.1,
  height: 0.9
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M8.6,174.9H5.6L4.1,172c-0.3-0.7,0.1-1.3,1.1-1.3l0,0c0.9,0,2,0.6,2.2,1.3L8.6,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M14.4,174.9h-3.1l-0.9-2.9c-0.2-0.7,0.4-1.3,1.3-1.3l0,0c0.9,0,1.9,0.6,2,1.3L14.4,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M20.2,174.9h-3l-0.4-2.9c-0.1-0.7,0.6-1.3,1.5-1.3l0,0c1,0,1.8,0.6,1.8,1.3L20.2,174.9L20.2,174.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M26,174.9h-3L23,172c0-0.7,0.8-1.3,1.8-1.3l0,0c1,0,1.6,0.6,1.5,1.3C26.4,172,26,174.9,26,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M31.7,174.9h-3l0.6-2.9c0.1-0.7,1.1-1.3,2-1.3l0,0c1,0,1.5,0.6,1.3,1.3L31.7,174.9L31.7,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M37.5,174.9h-3l1.2-2.9c0.3-0.7,1.3-1.3,2.2-1.3l0,0c1,0,1.4,0.6,1.1,1.3 C38.9,172,37.5,174.9,37.5,174.9z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st12",
  points: "34.7,156.6 21.5,97.7 21.2,97.7 8,156.6 -0.3,170.1 43,170.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "34.7,156.5 21.5,97.7 21.2,97.7 8,156.5  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "21.4,170.1 43,170.1 34.7,156.6 21.5,97.7 21.4,97.7  "
})), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M44.5,199h-6.1v-24.1l0,0l3-4.8H21.4v107.3h17.1v-50.8h0.2l5.2-7.5h0.6c0.4,0,0.7-0.3,0.7-0.7v-18.8 C45.2,199.3,44.9,199,44.5,199L44.5,199z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M282.2,86.8c-8.5-4.9-17,4.9-25.5,0v-6.5c8.5,4.9,17-4.9,25.5,0c-2.9-0.6-5.8,0.5-8.7,2.2 C276.4,83,279.3,84,282.2,86.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M256.7,105.8c-0.2,0-0.4-0.2-0.4-0.4V79.8c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4v25.6 C257.1,105.6,256.9,105.8,256.7,105.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 239.6,
  y: 174.9,
  className: "st10",
  width: 34.2,
  height: 102.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M233.5,199h46.6c0.2,0,0.4,0.2,0.4,0.4v19.4c0,0.2-0.2,0.4-0.4,0.4h-46.6c-0.2,0-0.4-0.2-0.4-0.4 v-19.4C233.1,199.2,233.3,199,233.5,199z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st11",
  points: "274,226.6 239.6,226.6 234.4,219.1 279.3,219.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st7",
  points: "273.8,174.9 239.6,174.9 236.6,170.1 276.8,170.1  "
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M235.9,214.8L235.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C236.6,214.4,236.3,214.8,235.9,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M239.4,214.8L239.4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C240.1,214.4,239.8,214.8,239.4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M242.9,214.8L242.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C243.6,214.4,243.3,214.8,242.9,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M246.4,214.8L246.4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C247.1,214.4,246.8,214.8,246.4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M249.9,214.8L249.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C250.6,214.4,250.3,214.8,249.9,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M253.4,214.8L253.4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C254.1,214.4,253.8,214.8,253.4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M256.9,214.8L256.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C257.6,214.4,257.3,214.8,256.9,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M260.4,214.8L260.4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C261.1,214.4,260.8,214.8,260.4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M263.9,214.8L263.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C264.6,214.4,264.3,214.8,263.9,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M267.4,214.8L267.4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C268.1,214.4,267.8,214.8,267.4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M270.9,214.8L270.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C271.6,214.4,271.3,214.8,270.9,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M274.4,214.8L274.4,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C275.1,214.4,274.8,214.8,274.4,214.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M277.9,214.8L277.9,214.8c-0.4,0-0.8-0.3-0.8-0.8v-11.5c0-0.4,0.3-0.8,0.8-0.8l0,0 c0.4,0,0.8,0.3,0.8,0.8V214C278.6,214.4,278.3,214.8,277.9,214.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M248.3,190.4h-3.9v-6.7c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2L248.3,190.4L248.3,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M246.7,181.7c-0.1,0-0.3,0-0.4,0c-1.1,0-2,0.9-2,2v6.7h0.8v-6.7 C245.2,182.7,245.8,181.9,246.7,181.7L246.7,181.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M249.5,191h-6.3c-0.2,0-0.3-0.1-0.3-0.3l0,0c0-0.2,0.1-0.3,0.3-0.3h6.3c0.2,0,0.3,0.1,0.3,0.3l0,0 C249.8,190.9,249.7,191,249.5,191z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 244.4,
  y: 191,
  className: "st11",
  width: 4.1,
  height: 0.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M258.8,190.4h-3.9v-6.7c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2L258.8,190.4L258.8,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M257.2,181.7c-0.1,0-0.3,0-0.4,0c-1.1,0-2,0.9-2,2v6.7h0.8v-6.7 C255.7,182.7,256.3,181.9,257.2,181.7L257.2,181.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M260,191h-6.3c-0.2,0-0.3-0.1-0.3-0.3l0,0c0-0.2,0.1-0.3,0.3-0.3h6.3c0.2,0,0.3,0.1,0.3,0.3l0,0 C260.3,190.9,260.2,191,260,191z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 254.9,
  y: 191,
  className: "st11",
  width: 4.1,
  height: 0.9
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M260.2,259h-6.8v-11.7c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4L260.2,259L260.2,259z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M257.5,243.9c-0.2-0.1-0.5-0.1-0.7-0.1c-1.9,0-3.4,1.5-3.4,3.4V259h1.4v-11.7 C254.8,245.6,255.9,244.2,257.5,243.9L257.5,243.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M262.4,260h-11c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h11c0.3,0,0.5,0.2,0.5,0.5l0,0 C262.9,259.8,262.7,260,262.4,260z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 253.4,
  y: 260,
  className: "st11",
  width: 7.1,
  height: 1.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M269.3,190.4h-3.9v-6.7c0-1.1,0.9-2,2-2l0,0c1.1,0,2,0.9,2,2L269.3,190.4L269.3,190.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M267.7,181.7c-0.1,0-0.3,0-0.4,0c-1.1,0-2,0.9-2,2v6.7h0.8v-6.7 C266.2,182.7,266.9,181.9,267.7,181.7L267.7,181.7z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M270.5,191h-6.3c-0.2,0-0.3-0.1-0.3-0.3l0,0c0-0.2,0.1-0.3,0.3-0.3h6.3c0.2,0,0.3,0.1,0.3,0.3l0,0 C270.8,190.9,270.7,191,270.5,191z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 265.4,
  y: 191,
  className: "st11",
  width: 4.1,
  height: 0.9
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M244,174.9h-3.1l-1.4-2.9c-0.4-0.7,0.1-1.3,1.1-1.3l0,0c0.9,0,2,0.6,2.2,1.3L244,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M249.8,174.9h-3.1l-0.9-2.9c-0.2-0.7,0.4-1.3,1.3-1.3l0,0c0.9,0,1.9,0.6,2,1.3L249.8,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M255.5,174.9h-3.1l-0.4-2.9c-0.1-0.7,0.6-1.3,1.5-1.3l0,0c0.9,0,1.8,0.6,1.8,1.3L255.5,174.9 L255.5,174.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M261.3,174.9h-3l0.1-2.9c0-0.7,0.8-1.3,1.8-1.3l0,0c1,0,1.6,0.6,1.5,1.3L261.3,174.9L261.3,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M267.1,174.9h-3l0.6-2.9c0.1-0.7,1.1-1.3,2-1.3l0,0c1,0,1.5,0.6,1.3,1.3L267.1,174.9L267.1,174.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M272.9,174.9h-3l1.2-2.9c0.3-0.7,1.3-1.3,2.2-1.3l0,0c1,0,1.4,0.6,1.1,1.3L272.9,174.9z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st12",
  points: "270.1,156.6 256.9,97.7 256.6,97.7 243.4,156.6 235.1,170.1 278.4,170.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "270.1,156.5 256.9,97.7 256.6,97.7 243.4,156.5  "
})), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "256.7,170.1 278.4,170.1 270.1,156.6 256.9,97.7 256.7,97.7  "
})), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M279.9,199h-6.1v-24.1l0,0l3-4.8h-20.1v107.3h17.1v-50.8h0.2l5.2-7.5h0.6c0.4,0,0.7-0.3,0.7-0.7v-18.8 C280.5,199.3,280.2,199,279.9,199L279.9,199z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M48.2,169.4H48c-1,0-1.9-0.9-1.9-1.9h4C50.1,168.6,49.2,169.4,48.2,169.4L48.2,169.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M53,168h-0.2c-1,0-1.9-0.9-1.9-1.9h4C54.9,167.2,54,168,53,168L53,168z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M42.7,181.1h-0.2c-1,0-1.9-0.9-1.9-1.9h4C44.5,180.2,43.7,181.1,42.7,181.1L42.7,181.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M45.3,183.4h-0.2c-1,0-1.9-0.9-1.9-1.9h4C47.2,182.5,46.3,183.4,45.3,183.4L45.3,183.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M42.7,185.9h-0.2c-1,0-1.9-0.9-1.9-1.9h4C44.5,185.1,43.7,185.9,42.7,185.9L42.7,185.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M50.2,192.9H50c-1,0-1.9-0.9-1.9-1.9h4C52.1,192,51.2,192.9,50.2,192.9L50.2,192.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M48.2,195.6H48c-1,0-1.9-0.9-1.9-1.9h4C50.1,194.7,49.2,195.6,48.2,195.6L48.2,195.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M44.8,193.8h-0.2c-1,0-1.9-0.9-1.9-1.9h4C46.7,193,45.8,193.8,44.8,193.8L44.8,193.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M69.8,174.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C71.7,173.6,70.9,174.4,69.8,174.4L69.8,174.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M67.8,177.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C69.7,176.6,68.9,177.4,67.8,177.4L67.8,177.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M70.9,180.1h4v0.8c0,0.6-0.5,1.1-1.1,1.1H72c-0.6,0-1.1-0.5-1.1-1.1L70.9,180.1L70.9,180.1L70.9,180.1z "
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M84.6,166.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C86.5,165.5,85.6,166.4,84.6,166.4L84.6,166.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M87.3,169h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C89.2,168.1,88.3,169,87.3,169L87.3,169z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M102.7,177.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C104.6,176.6,103.8,177.4,102.7,177.4L102.7,177.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M107.6,190.6h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C109.5,189.7,108.7,190.6,107.6,190.6L107.6,190.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M116,169h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C117.9,168.1,117.1,169,116,169L116,169z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M104.1,172.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C106,171.3,105.2,172.1,104.1,172.1L104.1,172.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M100.7,194.8h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C102.6,193.9,101.8,194.8,100.7,194.8L100.7,194.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M114.1,171.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C115.9,170.3,115.1,171.1,114.1,171.1L114.1,171.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M71,184.3h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C72.9,183.5,72.1,184.3,71,184.3L71,184.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M81.8,193.6h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C83.7,192.8,82.8,193.6,81.8,193.6L81.8,193.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M79.8,196.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C81.7,195.3,80.8,196.1,79.8,196.1L79.8,196.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M76.6,193.6h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C78.5,192.8,77.6,193.6,76.6,193.6L76.6,193.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M175.1,169.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C177,168.6,176.1,169.4,175.1,169.4L175.1,169.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M179.8,168h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C181.7,167.2,180.9,168,179.8,168L179.8,168z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M169.5,181.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C171.4,180.2,170.5,181.1,169.5,181.1L169.5,181.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M179.8,177.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C181.7,176.6,180.9,177.4,179.8,177.4L179.8,177.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M169.5,185.9h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C171.4,185.1,170.5,185.9,169.5,185.9L169.5,185.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M177.1,192.9h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C179,192,178.1,192.9,177.1,192.9L177.1,192.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M175.1,195.6h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C177,194.7,176.1,195.6,175.1,195.6L175.1,195.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M171.6,193.8h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C173.5,193,172.7,193.8,171.6,193.8L171.6,193.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M196.7,174.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C198.6,173.6,197.7,174.4,196.7,174.4L196.7,174.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M212,177.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C213.9,176.6,213,177.4,212,177.4L212,177.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M197.8,180.1h4v0.8c0,0.6-0.5,1.1-1.1,1.1h-1.7c-0.6,0-1.1-0.5-1.1-1.1L197.8,180.1L197.8,180.1 L197.8,180.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M226.9,166.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C228.8,165.5,228,166.4,226.9,166.4L226.9,166.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M214.1,169h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C216,168.1,215.2,169,214.1,169L214.1,169z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M232.5,183.4h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C234.4,182.5,233.5,183.4,232.5,183.4L232.5,183.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M234.5,190.6h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C236.4,189.7,235.5,190.6,234.5,190.6L234.5,190.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M158,169h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C159.9,168.1,159.1,169,158,169L158,169z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M231,172.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C232.9,171.3,232,172.1,231,172.1L231,172.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M227.6,194.8h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C229.5,193.9,228.6,194.8,227.6,194.8L227.6,194.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M162,178.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C163.9,177.3,163.1,178.1,162,178.1L162,178.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M213.2,184.3H213c-1.1,0-1.9-0.9-1.9-1.9h4C215.1,183.5,214.3,184.3,213.2,184.3L213.2,184.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M210,172.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C211.9,171.3,211,172.1,210,172.1L210,172.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M206.6,196.1h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C208.5,195.3,207.7,196.1,206.6,196.1L206.6,196.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st22",
  d: "M203.4,193.6h-0.2c-1.1,0-1.9-0.9-1.9-1.9h4C205.3,192.8,204.5,193.6,203.4,193.6L203.4,193.6z"
})));

function SvgQ9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.7 279.7",
    style: {
      enableBackground: "new 0 0 279.7 279.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000026130305967548132360000013922288484716672668_"
  }, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176754447707658243260000014962479954267690394_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176754447707658243260000014962479954267690394_)"
    }
  }, _ref5, _ref6))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ9);
export default __webpack_public_path__ + "static/media/q9.ea71ab3493dbc3fee53b77b0dae194a9.svg";
export { ForwardRef as ReactComponent };